import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getUserProperties(queryString) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/usersgroups/user-properties/data?" + queryString, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching user properties"
                    });
                }
            });
    },
    saveUserProperty(userPropDTO) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/usersgroups/user-properties", userPropDTO).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    getUserPropertyInfo(propertyId) {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/usersgroups/user-properties/" + propertyId, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching user property"
                    });
                }
            });
    },
    deleteUserProperty(userpropId) {
        axios.defaults.withCredentials = true;

        return axios.delete(constants.BASE_URL + "/usersgroups/user-properties/" + userpropId).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    }
}
